/**
 *
 * DisabledContainer
 *
 */

// Node_Module Imports
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import Anchor from 'common-ui-components/dist/components/Atoms/Anchor';
import EmptyContainer from 'common-ui-components/dist/components/Atoms/EmptyContainer';
import { getLabelWithComponent, isEProcurementUserOnECommerce } from '../../../utils/utils';
import {
  USER_STATE_LOGGED_IN,
  SET_SIGN_IN_REDIRECT_KEY,
  PARTIAL_ENABLED,
} from '../../../global/constants';

import './DisabledContainer.scss';

const DisabledContainer = ({
  userState,
  labels,
  signInUrl,
  contactUsLink,
  locator,
  onMount,
  countryEnabledStatus,
}) => {
  const signInAnchorProps = {
    className: 'row',
    elementLocator: `link-${locator}-disabled-sign-in`,
    to: signInUrl,
    onClick: () => {
      window.sessionStorage.setItem(SET_SIGN_IN_REDIRECT_KEY, window.location.href);
    },
  };
  const signInAnchor = (
    <Anchor {...signInAnchorProps}>
      <ReactSVG src="/static/images/user/user.svg" />
      {labels.signIn}
    </Anchor>
  );
  const contactUsAnchor = (
    <Anchor
      className="row"
      elementLocator={`link-${locator}-disabled-contact-us`}
      to={contactUsLink}
    >
      {labels.contactWaters}
    </Anchor>
  );
  const result =
    userState !== USER_STATE_LOGGED_IN && countryEnabledStatus === PARTIAL_ENABLED
      ? getLabelWithComponent(labels.disabledCartActionUnAuthenticatedUser, [
          signInAnchor,
          contactUsAnchor,
        ])
      : getLabelWithComponent(labels.disabledCartActionAuthenticatedUser, [contactUsAnchor]);

  const disabledCartMessage = isEProcurementUserOnECommerce()
    ? labels.disabledEProcUserCartMessage
    : labels.disabledCartMessage;

  useEffect(() => {
    onMount();
  }, []);

  return (
    <EmptyContainer className="container center-xs shoppingCartDisabled">
      <div className="disabledContainer-message">{disabledCartMessage}</div>
      <div className="center-xs row container">
        {result?.map(item => {
          if (typeof item === 'string') {
            return <span key={item}>{item}</span>;
          }
          return item;
        })}
      </div>
    </EmptyContainer>
  );
};

DisabledContainer.propTypes = {
  userState: PropTypes.oneOf(['LOGGED_IN', 'ANONYMOUS']),
  labels: PropTypes.shape({
    disabledCartMessage: PropTypes.string,
    contactWaters: PropTypes.string,
    signIn: PropTypes.string,
    disabledCartActionUnAuthenticatedUser: PropTypes.string,
    disabledCartActionAuthenticatedUser: PropTypes.string,
    disabledEProcUserCartMessage: PropTypes.string,
  }),
  signInUrl: PropTypes.string,
  contactUsLink: PropTypes.string,
  locator: PropTypes.string,
  onMount: PropTypes.func,
  countryEnabledStatus: PropTypes.string,
};

DisabledContainer.defaultProps = {
  userState: {},
  labels: {},
  signInUrl: '',
  contactUsLink: '',
  locator: '',
  onMount: () => {
    /* default onMount handler */
  },
  countryEnabledStatus: '',
};

export default DisabledContainer;
